import { render, staticRenderFns } from "./ComponentTouristTours.vue?vue&type=template&id=502451a5&"
import script from "./ComponentTouristTours.vue?vue&type=script&lang=js&"
export * from "./ComponentTouristTours.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports